import { CheckoutState } from '../state';
import { PaypalScriptStatus } from '../state/paypal';
import {
    areAsyncExpressCheckoutEligibleCommonRulesMet,
    areSyncExpressCheckoutEligibleCommonRulesMet,
    isPaypalAvailableAsPaymentMethod,
} from './expressCheckout';

export const areSyncExpressPaypalEligibleRulesMet = (state: CheckoutState) =>
    areSyncExpressCheckoutEligibleCommonRulesMet(state);

export const areAsyncExpressPaypalEligibleRulesMet = (state: CheckoutState) =>
    areAsyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isPaypalAvailableAsPaymentMethod(state) &&
    getPaypalScriptStatus(state) !== PaypalScriptStatus.failed;

export const isExpressPaypalEnabled = (state: CheckoutState) =>
    areSyncExpressPaypalEligibleRulesMet(state) &&
    areAsyncExpressPaypalEligibleRulesMet(state);

export const getPaypalScriptStatus = (state: CheckoutState) => {
    return state.paypal?.scriptStatus;
};

export const isLoadingPaypal = (state: CheckoutState) =>
    state.paypal.isLoadingPaypal;
